(() => {
  'use strict';

  // Bambú Home:
  // Motor antiguo de recomendaciones desactivado.
  // Las recomendaciones ahora son administradas únicamente
  // por Bambú Promo Manager.

  try {
    window.BHCartRecommendations?.controller?.abort?.();
  } catch (_) {}

  document.querySelectorAll(
    '.bh-cart-reco-hub, [data-bh-cart-reco-entry], [data-bh-cart-reco-modal]'
  ).forEach(element => element.remove());

  window.BHCartRecommendations = {
    version: 'disabled-app-only',
    refresh() {},
    open() {},
    close() {},
    getState() {
      return {
        cart: null,
        products: [],
        sections: {
          primary: [],
          secondary: []
        }
      };
    }
  };
})();